// import { useGetTopMarqueeBanner } from '@/lib/hooks/services/useGetTopMarqueeBanner'
import { cn } from '@/lib/utils'
import useGlobalStore from '@/store/useGlobalStore'
import React, { useEffect, useRef, useState } from 'react'
import Marquee from 'react-fast-marquee'
import type { LucideIcon } from 'lucide-react'

type Props = {
  text: string
  textColor?: string | null
  backgroundColor?: string | null
  isMarquee?: boolean
  className?: string
  iconComponent?: LucideIcon
}

export const AlertBanner = ({
  text,
  textColor,
  backgroundColor,
  isMarquee = false,
  className,
  iconComponent: IconComponent,
}: Props) => {
  const textRef = useRef<HTMLSpanElement>(null)
  const [isTextTooLong, setIsTextTooLong] = useState(false)
  const {
    app: { flashSaleAppeared },
    setApp,
  } = useGlobalStore()

  const isMarqueeEnabled = isMarquee && isTextTooLong

  useEffect(() => {
    if (!isMarquee) return

    setTimeout(() => {
      setApp({ flashSaleAppeared: true })
    }, 1000)
    const checkTextWidth = () => {
      if (textRef.current) {
        const textWidth = textRef.current.offsetWidth
        const containerWidth = textRef.current.parentElement!.offsetWidth
        if (textWidth > containerWidth) {
          setIsTextTooLong(true)
        } else {
          setIsTextTooLong(false)
        }
      }
    }
    checkTextWidth()

    // Optional chaining added to prevent app crashing on older browsers, like Safari 16
    window.screen?.orientation?.addEventListener('change', checkTextWidth)
    // eslint-disable-next-line consistent-return
    return () => {
      window.screen?.orientation?.removeEventListener('change', checkTextWidth)
    }
  }, [setApp, text, isMarquee])

  return (
    <div
      className={cn(
        'flex justify-center overflow-hidden bg-primary p-2 text-white',
        flashSaleAppeared
          ? 'transition duration-500 ease-in-out'
          : '-translate-y-full transition duration-300',
        isMarquee ? 'whitespace-nowrap' : ' text-center',
        className,
      )}
      style={{
        backgroundColor: backgroundColor ?? undefined,
        color: textColor ?? undefined,
      }}
    >
      <span
        className={cn('flex gap-x-2', isMarqueeEnabled ? 'hidden' : '')}
        ref={textRef}
      >
        {IconComponent && <IconComponent />}

        <div
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </span>
      {isMarqueeEnabled && (
        <Marquee delay={3} play={true} pauseOnHover speed={40}>
          <div>
            <div
              dangerouslySetInnerHTML={{
                __html: text,
              }}
            />
          </div>
        </Marquee>
      )}
    </div>
  )
}
